module.exports = __webpack_public_path__ + "media/images/spree/frontend/logo/spree_50-04d119f82191c479a9c6d894e279585d.png";